import { Link as UILink, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { Link as TLink } from "../types/Modify";

interface Props {
  config: Omit<TLink, "controltype">;
}
type Component = (props: Props) => JSX.Element;

export const Link: Component = ({ config }) => {
  const { text, to } = config;

  const renderLink = () => {
    if (to) {
      return (
        <UILink
          component={RouterLink}
          to={to}
          color="primary"
          underline="always"
        >
          {text}
        </UILink>
      );
    }
    return (
      <UILink color="primary" underline="always">
        {text}
      </UILink>
    );
  };

  return (
    <Typography role="link" {...config}>
      {renderLink()}
    </Typography>
  );
};
